export class SIQLauncherUnreadBadgeTheme {
  backgroundColor = "null";
  textColor = "null";
  borderColor = "null";
  borderWidth = null; // Int
}
//# sourceMappingURL=SIQLauncherUnreadBadgeTheme.js.map